// extracted by mini-css-extract-plugin
export default {"modalCtner":"Modal_modalCtner__HGzNL","innerModalCtner":"Modal_innerModalCtner__w7lW4","textCtner":"Modal_textCtner__Mrer4","closeWidgetIcon":"Modal_closeWidgetIcon__3BhK0"};